export const getQuadVertices = (mW: number, mH: number, oX = 0, oY = 0) => {
  oX = oX * -1 || 0;
  oY = oY * -1 || 0;
  return new Float32Array([
    oX,
    oY,
    oX,
    mH + oY,
    mW + oX,
    mH + oY,
    oX,
    oY,
    mW + oX,
    mH + oY,
    mW + oX,
    oY,
  ]);
};

export const getQuadIndexedVertices = (w: number, h: number, x = 0, y = 0) => {
  return new Float32Array([
    x,
    y, // 0
    x,
    y + h, // 1
    x + w,
    y + h, // 2
    x + w,
    y, // 3
  ]);
};
